"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCollection = exports.getFloorPrice = exports.withdrawFungible = exports.getTraits = exports.getProtocolFee = exports.getAssetsToWithdraw = exports.getTokens = exports.cancelOffer = exports.rejectOffer = exports.acceptOffer = exports.makeOffer = exports.getAllNFTs = void 0;
const request_formatters_1 = require("../request-formatters");
const formatter_types_1 = require("../formatter-types");
const response_formatters_1 = require("../response-formatters");
const IndexNotFound = -1;
exports.getAllNFTs = {
    request: (params) => {
        return {
            reverse: (0, request_formatters_1.wrap)(params.reverse),
            traits: (0, request_formatters_1.wrap)((0, request_formatters_1.serializeTraits)(params.traits)),
            count: (0, request_formatters_1.wrap)(params.count),
            last_index: (0, request_formatters_1.wrap)(params.lastIndex),
            sort_key: params.sortKey || formatter_types_1.SortKey.all,
            buyer: (0, request_formatters_1.wrap)(params.buyer),
            search: (0, request_formatters_1.wrap)(params.search)
        };
    },
    response: (response, collection) => {
        const data = response.data.map((nft) => (0, response_formatters_1.deserializeTokenData)(nft, collection));
        return {
            data,
            error: (0, response_formatters_1.unwrap)(response.error),
            lastIndex: (0, response_formatters_1.unwrap)(response.last_index),
            total: response.total
        };
    }
};
exports.makeOffer = {
    request: (params, collectionId) => {
        const collection = (0, request_formatters_1.getPrincipal)(collectionId);
        return {
            token_id: params.tokenId,
            collection,
            seller: [],
            buyer: [],
            caller: [],
            fungible_id: [],
            version: [BigInt(2)],
            price: (0, request_formatters_1.wrap)(params.price)
        };
    },
    response: (response, collection) => {
        return (0, response_formatters_1.getResultStatus)(response, (data) => (0, response_formatters_1.deserializeTokenData)(data, collection));
    }
};
exports.acceptOffer = {
    request: (params, collectionId) => {
        return {
            token_id: params.tokenId,
            collection: collectionId,
            buyer: [params.buyer],
            seller: [],
            caller: [],
            fungible_id: [],
            version: [],
            price: []
        };
    },
    response: (response, collection) => {
        return (0, response_formatters_1.getResultStatus)(response, (data) => (0, response_formatters_1.deserializeTokenData)(data, collection));
    }
};
exports.rejectOffer = {
    request: (params, collectionId) => {
        return {
            token_id: params.tokenId,
            collection: collectionId,
            buyer: [params.buyer],
            seller: [],
            caller: [],
            fungible_id: [],
            version: [],
            price: []
        };
    },
    response: (response, collection) => {
        return (0, response_formatters_1.getResultStatus)(response, (data) => (0, response_formatters_1.deserializeTokenData)(data, collection));
    }
};
exports.cancelOffer = {
    request: (params, collectionId) => {
        return {
            token_id: params.tokenId,
            collection: collectionId,
            buyer: [],
            seller: [],
            caller: [],
            fungible_id: [],
            version: [],
            price: []
        };
    },
    response: (response, collection) => {
        return (0, response_formatters_1.getResultStatus)(response, (data) => (0, response_formatters_1.deserializeTokenData)(data, collection));
    }
};
exports.getTokens = {
    request: (params, collectionId) => {
        return [(0, request_formatters_1.getPrincipal)(collectionId), params.ids];
    },
    response: (result, collection) => {
        if ('Ok' in result) {
            const invalidItemIndex = result.Ok.findIndex((item) => item.id === '');
            const invalidIdsFound = invalidItemIndex !== IndexNotFound;
            if (invalidIdsFound) {
                return (0, response_formatters_1.getResultStatus)({
                    Err: { NotFound: 'A token id is invalid, verify your id list and remove the invalid ids' }
                });
            }
        }
        return (0, response_formatters_1.getResultStatus)(result, (data) => data.map((token) => (0, response_formatters_1.deserializeTokenData)(token, collection)));
    }
};
exports.getAssetsToWithdraw = {
    response: (response) => {
        return response.map((item) => ({
            fungibleCanisterId: item[0],
            balance: item[1]
        }));
    }
};
exports.getProtocolFee = {
    response: (fee) => {
        return (0, response_formatters_1.deserializeFeePercentage)(fee);
    }
};
exports.getTraits = {
    response: (result) => {
        return (0, response_formatters_1.deserializeAllTraits)(result);
    }
};
exports.withdrawFungible = {
    request: (params) => {
        return [params.fungibleId, { [params.fungibleStandard]: null }];
    },
    response: (response) => {
        return (0, response_formatters_1.getResultStatus)(response);
    }
};
exports.getFloorPrice = {
    response: (response) => {
        return (0, response_formatters_1.getResultStatus)(response, (data) => data);
    }
};
exports.getCollection = {
    request: (params) => {
        return (0, request_formatters_1.getPrincipal)(params.principalId);
    },
    response: (response) => {
        return (0, response_formatters_1.getResultStatus)(response, (data) => (0, response_formatters_1.deserializeCollection)(data));
    }
};
